import instance from "../axios";

const getOrders = (eventId: number) => {
  let res;
  try {
    res = instance.get(
      `Admin/Orders/GetEventTableOrders?IdEvent=${eventId}&Deleted=false`
    );
  } catch (error) {
    console.error(error);
    res = error;
  } finally {
    return res;
  }
};

const getFileToDownload = (eventId: number) => {
  return instance.get(`Admin/Orders/ExportOrdersXLSX?IdEvent=${eventId}`);
};

const deleteOrder = (id: number) => {
  return instance.delete(`Admin/Orders/DeleteTableOrder`, {
    data: { IdTableOrder: id },
  });
};

const OrdersService = {
  getOrders,
  deleteOrder,
  getFileToDownload,
};

export default OrdersService;
